import React from "react";
import RaisedStyleContainer from "../../Componant/Buttons/RaisedStyle";

const RaisedStyle = () => {
  return (
    <div className="page-body">
      <RaisedStyleContainer />
    </div>
  );
};

export default RaisedStyle;
